import { useGuardedNavigate } from "../context/AuthModalContext";
import { useTranslation } from "../context/TranslationContext";
import Button from "./ds/Button";
import Icon from "./ds/Icon";

/**
 * About page — Mintly pricing: start free, pay only performance-based commission
 * (Figma "Pricing").
 */
export function MintlyFreeForeverSection() {
  const { t } = useTranslation();
  const navigate = useGuardedNavigate();

  return (
    <section className="flex flex-col gap-space-12 rounded-radius-lg bg-bg-raised p-space-24 lg:p-space-40">
      <h2 className="text-title-1 text-label-primary">{t("resources.pricingTitle")}</h2>
      <div className="grid grid-cols-1 gap-space-24 lg:grid-cols-2 lg:gap-space-48">
        <div className="flex flex-col gap-[10px]">
          <h3 className="text-headline text-label-primary">{t("resources.pricingCreateSpaceTitle")}</h3>
          <p className="text-caps-label uppercase text-label-secondary">{t("resources.pricingFeaturesLabel")}</p>
          <ul className="flex flex-col gap-[10px]">
            {[1, 2, 3].map((n) => (
              <li key={n} className="flex items-center gap-space-8 text-subheadline text-label-primary">
                <Icon name="check" size={18} className="shrink-0 text-accent-text" />
                {t(`resources.pricingFeature${n}`)}
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col items-start gap-[10px] rounded-[24px] bg-bg-inset p-[28px]">
          <h3 className="text-headline text-label-primary">{t("resources.pricingHeroTitle")}</h3>
          <p className="text-large-title text-label-primary">{t("resources.pricingPriceLine")}</p>
          <p className="text-subheadline text-label-secondary">{t("resources.pricingCommissionLine")}</p>
          <Button onClick={() => navigate("/create-business")}>{t("resources.pricingCta")}</Button>
        </div>
      </div>
    </section>
  );
}
